import { render } from "./ControllerForce.vue?vue&type=template&id=d3f4d762&scoped=true"
import script from "./ControllerForce.vue?vue&type=script&lang=js"
export * from "./ControllerForce.vue?vue&type=script&lang=js"

import "./ControllerForce.vue?vue&type=style&index=0&id=d3f4d762&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f4d762"]])

export default __exports__